import { useContext } from 'react';
import { PrismBridgeContext, type PrismAuth } from './PrismBridgeProvider';

export function usePrismAuth(): PrismAuth {
  const ctx = useContext(PrismBridgeContext);
  if (!ctx) {
    throw new Error('usePrismAuth must be used within <PrismBridgeProvider>');
  }
  return ctx;
}
